<template>
	<div>
		<div class="flex">
			<BaseInput
				ref="BaseInput.model.street"
				:required="true"
				class="w-full md:w-1/2 pr-0 md:pr-2"
				:label="$t('street_postal_box')"
				:disabled="disabled"
				:placeholder="$t('street_postal_box')"
				type="text"
				v-model="value.street"
			/>

			<BaseInput
				ref="BaseInput.model.houseNumber"
				class="w-full md:w-1/2 md:pl-2"
				:label="$t('number')"
				:placeholder="$t('number')"
				:disabled="disabled"
				:required="false"
				type="tel"
				v-model="value.houseNumber"
			/>
		</div>

		<CityInput ref="BaseInput-zip" v-model="value.city" :disabled="disabled" :zip-code-required="zipCodeRequired" />
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import CityInput from '@/components/forms/CityInput';
import { isNumeric } from '@/helpers/Utils';

export default {
	name: 'AddressInput',
	components: { BaseInput, CityInput },
	props: {
		disabled: { default: false },
		value: {},
	},
	data() {
		return {};
	},
	computed: {
		zipCodeRequired() {
			// if street is Postleitzahl
			return !this.value.street || !isNumeric(this.value.street);
		},
	},
	methods: {},
};
</script>
